import LoyaltyProgramGuestSFC from "./LoyaltyProgramGuest.vue";
export const LoyaltyProgramGuest = LoyaltyProgramGuestSFC;
